import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatSidenav } from '@angular/material/sidenav';
import { NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

const MOBILE_VIEW = 'screen and (max-width: 768px)';
const TABLET_VIEW = 'screen and (min-width: 769px) and (max-width: 1024px)';
const MONITOR_VIEW = 'screen and (min-width: 1024px)';

@Component({
  selector: 'app-full',
  templateUrl: './full.component.html',
  styleUrls: [],
})
export class FullComponent implements OnInit {

  @ViewChild('leftsidenav')
  public sidenav: MatSidenav | any;

  //get options from service
  private layoutChangesSubscription = Subscription.EMPTY;
  private isMobileScreen = false;
  private isContentWidthFixed = true;
  private isCollapsedWidthFixed = false;
  private htmlElement!: HTMLHtmlElement;

  get isOver(): boolean {
    return this.isMobileScreen;
  }

  // Self-contained consoles (vendor + customer) render their own sidebar and
  // topbar, so the outer FullComponent header must be hidden and the page
  // wrapper switched to fullscreen mode for them.
  isFullscreenConsole = false;
  isVendorConsole = false;
  hideHeader = false;

  private static readonly HEADERLESS_ROUTES = [
    '/customers/login',
    '/customers/signup',
    '/vendors/login',
    '/vendors/register',
  ];

  constructor(private breakpointObserver: BreakpointObserver, private router: Router) {
    this.htmlElement = document.querySelector('html')!;
    this.layoutChangesSubscription = this.breakpointObserver
      .observe([MOBILE_VIEW, TABLET_VIEW, MONITOR_VIEW])
      .subscribe((state) => {
        // SidenavOpened must be reset true when layout changes

        this.isMobileScreen = state.breakpoints[MOBILE_VIEW];

        this.isContentWidthFixed = state.breakpoints[MONITOR_VIEW];
      });
  }

  private isConsoleUrl(url: string): boolean {
    return (
      url.includes('/workspace/vendor') ||
      url.includes('/workspace/customer') ||
      url.includes('/workspace/internal-team')
    );
  }

  ngOnInit(): void {
    this.isFullscreenConsole = this.isConsoleUrl(this.router.url);
    this.isVendorConsole = this.router.url.includes('/workspace/vendor');
    this.hideHeader = this.matchesHeaderlessRoute(this.router.url);
    this.layoutChangesSubscription.add(
      this.router.events.pipe(filter(e => e instanceof NavigationEnd)).subscribe((e: any) => {
        this.isVendorConsole = e.urlAfterRedirects.includes('/workspace/vendor');
        this.hideHeader = this.matchesHeaderlessRoute(e.urlAfterRedirects);
        this.isFullscreenConsole = this.isConsoleUrl(e.urlAfterRedirects);
      })
    );
  }

  private matchesHeaderlessRoute(url: string): boolean {
    const path = url.split('?')[0].split('#')[0];
    return FullComponent.HEADERLESS_ROUTES.some(r => path === r || path.startsWith(r + '/'));
  }

  ngOnDestroy() {
    this.layoutChangesSubscription.unsubscribe();
  }

  toggleCollapsed() {
    this.isContentWidthFixed = false;
  }

  onSidenavClosedStart() {
    this.isContentWidthFixed = false;
  }

  onSidenavOpenedChange(isOpened: boolean) {
    this.isCollapsedWidthFixed = !this.isOver;
  }
}
